import { css } from "theme/default/css";

export const setFlexDFAICJCSA = css`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;
